import { getRouteProperties } from './analyticsConfig.js';
import { testClubPlacements } from './shared/testClubInvitation.js';

const placements = { ...testClubPlacements, '/test-club': 'landing-hero' };

export const createTestClubClickHandler = (getPathname, capture) => (event) => {
  // Keyboard activation emits click; middle-button activation emits auxclick.
  if (event.type === 'click' ? event.button !== 0 : event.type !== 'auxclick' || event.button !== 1) {
    return;
  }

  const link = event.target?.closest?.('a[data-test-club-cta]');
  if (!link) return;

  const route = getRouteProperties(getPathname());
  const placement = route && Object.hasOwn(placements, route.pathname) ? placements[route.pathname] : null;
  if (!placement || link.getAttribute('data-test-club-cta') !== placement) return;

  // Only fixed route and placement values reach capture. Never read link text or URLs.
  try {
    capture({ pathname: route.pathname, placement });
  } catch {
    // Analytics must never interrupt navigation.
  }
};
